export enum ToggleKey {
  LAST_SEEN_CINEMA = "search_stomachshop_last_seen_cinema",
}
